export default __webpack_public_path__ + "assets/models/88ddf83395868cdbcb6562937c52d828.glb";